import { render, staticRenderFns } from "./PopupRemoveFavorites.vue?vue&type=template&id=1d4342e6&scoped=true"
import script from "./PopupRemoveFavorites.vue?vue&type=script&lang=js"
export * from "./PopupRemoveFavorites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4342e6",
  null
  
)

export default component.exports